/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Deliverable_AnswerInputs */



/**
* | output |
* | --- |
* | "An answer in the chat" |
*
* @param {Agent_Builder_Deliverable_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_deliverable_answer = /** @type {((inputs?: Agent_Builder_Deliverable_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Deliverable_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Antwort im Chat")
	return /** @type {LocalizedString} */ ("An answer in the chat")
});